// src/components/gestionEvento/siembraManager/SiembraTable.js
import React from 'react';
import {
  Table, TableHead, TableRow, TableCell,
  TableBody, Checkbox, Select, MenuItem, FormControl,
  TableContainer, Paper
} from '@mui/material';
import { pistaOptions, campoOptions } from './siembraOptions';
import { isCampo } from './isCampo';

export default function SiembraTable({
  schedules,
  pruebasConfig,
  onConfigChange,
  selectedRows,
  onSelectRow,
}) {
  // Para "seleccionar todo" en esta tabla, necesitamos saber:
  const allIds = schedules.map((s) => s.id);
  const allSelected = allIds.every((id) => selectedRows.has(id));
  const someSelected = allIds.some((id) => selectedRows.has(id));
  const isIndeterminate = someSelected && !allSelected;

  // Manejar el click en el header checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    if (checked) {
      // Seleccionar todos
      allIds.forEach((id) => onSelectRow(id, true));
    } else {
      // Deseleccionar todos
      allIds.forEach((id) => onSelectRow(id, false));
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        // Solo scroll horizontal
        overflowX: 'auto',
        overflowY: 'hidden',
        mb: 2,
        // Ajustar minWidth si quieres que haya scroll horizontal
        minWidth: 900,
      }}
    >
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                checked={allSelected}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            </TableCell>
            <TableCell>#Evento</TableCell>
            <TableCell>Prueba</TableCell>
            <TableCell>Categoría</TableCell>
            <TableCell>Rama</TableCell>
            <TableCell>Avance</TableCell>
            <TableCell>Asig. Heats</TableCell>
            <TableCell>Asig. Posiciones</TableCell>
            <TableCell>Orden Heat</TableCell>
            <TableCell>Tipo Rondas</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schedules.map((sched) => {
            const config = pruebasConfig[sched.id] || {};
            const fieldEvent = isCampo(sched);
            const opts = fieldEvent ? campoOptions : pistaOptions;

            return (
              <TableRow key={sched.id} hover>
                {/* Checkbox de cada fila */}
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedRows.has(sched.id)}
                    onChange={(e) => onSelectRow(sched.id, e.target.checked)}
                  />
                </TableCell>

                <TableCell>{sched.evento}</TableCell>
                <TableCell>{sched.prueba}</TableCell>
                <TableCell>{sched.categoria}</TableCell>
                <TableCell>{sched.rama}</TableCell>

                {/* Avance */}
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={config.avance || ''}
                      onChange={(e) => onConfigChange(sched.id, 'avance', e.target.value)}
                    >
                      {opts.avance.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>

                {/* Asignación Heats */}
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={config.asignacionHeats || ''}
                      onChange={(e) => onConfigChange(sched.id, 'asignacionHeats', e.target.value)}
                    >
                      {opts.asignacionHeats.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>

                {/* Asignación Posiciones */}
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={config.asignacionPosiciones || ''}
                      onChange={(e) =>
                        onConfigChange(sched.id, 'asignacionPosiciones', e.target.value)
                      }
                    >
                      {opts.asignacionPosiciones.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>

                {/* Orden Heat */}
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={config.ordenHeat || ''}
                      onChange={(e) => onConfigChange(sched.id, 'ordenHeat', e.target.value)}
                    >
                      {opts.ordenHeat.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>

                {/* Tipo Rondas */}
                <TableCell>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={config.tipoRondas || ''}
                      onChange={(e) => onConfigChange(sched.id, 'tipoRondas', e.target.value)}
                    >
                      {opts.tipoRondas.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>

              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
